var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 76,
    viewBox: "0 0 213 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.188 0H61.0939V76H122.188V0Z",
    fill: "#9FC1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0939 22.1309H0V76.0015H61.0939V22.1309Z",
    fill: "#9FC1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.002 36.0962H142.414V76.0015H213.002V36.0962Z",
    fill: "#BDD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.908 0H90.8138V76H151.908V0Z",
    fill: "#BDD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0704 22.1309H29.7216V76.0015H99.0704V22.1309Z",
    fill: "#BDD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.213 33.5866H121.163L118.043 35.0705L117.414 32.2043L121.742 30.1934H124.912V46.537H121.213V33.5881V33.5866Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5208 57.2625V54.9498L56.6347 53.039C60.2083 49.846 61.9434 48.0102 61.9935 46.0994C61.9935 44.7671 61.1877 43.71 59.3008 43.71C57.8926 43.71 56.6597 44.4137 55.8038 45.0673L54.7211 42.3262C55.954 41.3958 57.866 40.6421 60.08 40.6421C63.7787 40.6421 65.8159 42.8047 65.8159 45.771C65.8159 48.5121 63.8288 50.6997 61.4631 52.8123L59.9532 54.0695V54.1195H66.1178V57.2625H54.5193H54.5208Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.093 59.8393C178.772 60.1911 180.332 60.8447 181.892 60.8447C183.881 60.8447 184.887 59.8893 184.887 58.6571C184.887 57.0481 183.277 56.3179 181.59 56.3179H180.03V53.5767H181.515C182.798 53.5517 184.433 53.0748 184.433 51.6909C184.433 50.7105 183.627 49.9818 182.017 49.9818C180.684 49.9818 179.275 50.5604 178.595 50.9622L177.815 48.1961C178.796 47.5675 180.758 46.9639 182.872 46.9639C186.369 46.9639 188.306 48.7996 188.306 51.0373C188.306 52.773 187.325 54.1303 185.311 54.8339V54.884C187.273 55.2358 188.858 56.7197 188.858 58.8573C188.858 61.7485 186.317 63.8611 182.164 63.8611C180.051 63.8611 178.265 63.3075 177.308 62.704L178.089 59.8377L178.093 59.8393Z",
    fill: "#233862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.b73a3764a6045459c6f602051ae97442.svg";
export { ForwardRef as ReactComponent };